
import React, { useEffect, useState, useRef } from 'react';
import Layout from '@/components/Layout';
import UserNotifications from '@/components/UserNotifications';
import OneSignalSettings from '@/components/OneSignalSettings';
import { useAuth } from '@/contexts/AuthContext';
import { Navigate } from 'react-router-dom';
import { Spinner } from '@/components/Spinner';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';

const Notifications = () => {
  const { user, isLoading } = useAuth();
  const [pageLoaded, setPageLoaded] = useState(false);
  
  useEffect(() => {
    if (process.env.NODE_ENV !== 'production') {
      console.log("[Notifications] Component mounted, user state:", user);
    }
    
    if (user) {
      if (process.env.NODE_ENV !== 'production') {
        console.log("[Notifications] User authenticated:", user.id);
      }
      setPageLoaded(true);
    }
    
    const timeout = setTimeout(() => {
      if (!pageLoaded) {
        setPageLoaded(true);
      }
    }, 2000);
    
    return () => {
      clearTimeout(timeout);
    }
  }, [user, pageLoaded]);

  if (isLoading && !pageLoaded) {
    if (process.env.NODE_ENV !== 'production') {
      console.log("[Notifications] Auth is still loading, showing spinner");
    }
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Spinner size="lg" />
      </div>
    );
  }

  if (!user && pageLoaded) {
    if (process.env.NODE_ENV !== 'production') {
      console.log("[Notifications] No user, redirecting to login");
    }
    return <Navigate to="/login" />;
  }

  if (process.env.NODE_ENV !== 'production') {
    console.log("[Notifications] User authenticated, showing notifications");
  }
  
  return (
    <Layout>
      <div className="container mx-auto px-4 py-8">
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-2xl font-bold text-vegana-primary">Notificaciones</h1>
        </div>
        
        <Card className="mb-6 border-green-300 bg-green-50">
          <CardHeader className="py-3">
            <CardTitle className="text-green-800 flex items-center text-base">
              🎉 ¡Notificaciones mejoradas!
            </CardTitle>
            <CardDescription className="text-green-700">
              Activa las notificaciones para recibir consejos nutricionales personalizados y recordatorios directamente en tu dispositivo.
            </CardDescription>
          </CardHeader>
        </Card>
        
        <div className="max-w-4xl mx-auto space-y-6">
          <OneSignalSettings />
          <UserNotifications />
        </div>
      </div>
    </Layout>
  );
};

export default Notifications;
